import { useCallback, useMemo } from 'react';
import { sortBy, uniqBy } from 'lodash';
import { getCategory } from 'feature-components/reports/item-assessment-report/columns/common-columns';
import { useURLSearchParams } from 'hooks/useURLSearchParams';
import type { BaseTestItem, Category } from 'services/assist-api/entities/test-item/test-items';

export function useCategoriesFromItems(items: BaseTestItem[]): Category[] {
  return useMemo(
    () =>
      sortBy(
        uniqBy(
          items.map((q) => getCategory(q.categories)).filter((cat) => cat !== undefined),
          (cat) => cat.id
        ),
        (cat) => cat.order,
        (cat) => cat.id
      ),
    [items]
  );
}

export function useQuestionLink(): (id: number) => string {
  const searchParams = useURLSearchParams();
  return useCallback(
    (id: number): string => {
      searchParams.set('type', 'individualitem');
      searchParams.set('questionId', `${id}`);
      return `../../individualitem?${searchParams.toString()}`;
    },
    [searchParams]
  );
}
